import { forwardRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MediaService } from 'src/app/Services/media.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Busyable } from 'src/app/shared/editors/busyable';

@Component({
    selector: 'app-mediaupload',
    templateUrl: './mediaupload.component.html',
    styleUrls: ['./mediaupload.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MediaUploadComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class MediaUploadComponent extends Busyable implements OnInit, OnChanges, ControlValueAccessor {

  private static NextUploadInputId = 0;

  @Input()
  public MediaId: any;
  @Input()
  public base64string: SafeUrl = "";
  @Input()
  public Name: string = "";
  @Input()
  public Width: any = 400;
  @Input()
  public Height: any = 300;
  @Input()
  public Type: string = "";
  @Input()
  public Color: string = "";

  public FileType: string = "";

  @Input()
  public ImageCategory?: string;

  @Input()
  public IsPublic: boolean = false;

  @Output()
  public MediaIdChange = new EventEmitter<number | null>();

  public UploadInputId = `media-upload-${MediaUploadComponent.NextUploadInputId++}`;

  constructor(public mediaService: MediaService, private domSanitizer: DomSanitizer) {
    super();
  }

  public writeValue(val: string): void {
    this.SetMediaId(val);
  }
  public onChange = (val: string | null) => { };
  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  public onTouched = () => { };
  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public GetMediaBase64() {
    if (this.MediaId == null || this.MediaId == "") {
      this.base64string = "";
      this.Name = "";
      this.StopLoading();
      return;
    }

    this.Loading();
    this.mediaService.GetBase64Media(this.MediaId).subscribe(result => {
      var string = result.Base64Prefix + result.Base64String;
      this.base64string = this.domSanitizer.bypassSecurityTrustUrl(string);
      this.Name = result.Name;
      this.StopLoading();
    }, () => {
      this.StopLoading();
    });
  }

  ngOnInit(): void {
    this.SetMediaId(this.MediaId);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["MediaId"] != null && !changes["MediaId"].firstChange) {
      this.SetMediaId(changes["MediaId"].currentValue);
    }
  }

  public UploadImage(image: any, imageCategory?: string) {
    if (image.target.files == null || image.target.files.length == 0) {
      return;
    }

    this.Loading();
    var file = image.target.files[0] as File;
    this.FileType = file.type;
    var pub = this.IsPublic;

    var fileByteArray: number[] = [];
    var reader = new FileReader();
    reader.onload = () => {
      var arrayBuffer = reader.result as ArrayBuffer,
        array = new Uint8Array(arrayBuffer)
      for (var i = 0; i < array.length; i++) {
        fileByteArray.push(array[i]);
      }
      this.mediaService.UploadMedia(fileByteArray, file.name, imageCategory, pub).subscribe(result => {
        this.MediaId = result;
        this.Name = file.name;
        this.MediaIdChange.emit(result);
        this.onChange(result.toString());
        this.GetMediaBase64();
      }, () => {
        this.StopLoading();
      });
    }
    reader.onerror = () => {
      this.StopLoading();
    };
    reader.readAsArrayBuffer(file);
  };

  private SetMediaId(val: any): void {
    if (val == null || val == "") {
      this.MediaId = val;
      this.base64string = "";
      this.Name = "";
      this.StopLoading();
      return;
    }

    if (this.MediaId == val && this.Name != "") {
      return;
    }

    this.MediaId = val;
    this.FileType = "image/" + this.Type.replace(".", "") + (this.Type == ".svg" ? "+xml" : "");
    this.GetMediaBase64();
  }

}
